module.exports = __webpack_public_path__ + "media/images/page/privilege_ttl-76aee5c081b0df635324cbec3a9ecea2.png";